import { useEffect, useState } from 'react';
import axios from 'axios';
import { DEFAULT_PAGE_IMAGES, mergePageImages } from '../utils/pageImageDefaults';

const apiUrl = process.env.REACT_APP_API_URL || '/api';

export function usePageImages() {
  const [images, setImages] = useState(DEFAULT_PAGE_IMAGES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchPageImages() {
      try {
        const response = await axios.get(`${apiUrl}/page-images`);
        if (!cancelled) {
          setImages(mergePageImages(response.data));
        }
      } catch {
        if (!cancelled) {
          setImages(DEFAULT_PAGE_IMAGES);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    fetchPageImages();

    return () => {
      cancelled = true;
    };
  }, []);

  return { images, loading };
}
